export default "<react-component name=LineSheetComponent props=vm />";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/linesheet/lineSheetReact.tpl.html
// module id = 748
// module chunks = 0